"use strict";
/**
 *
 * Button
 *
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const styles_1 = require("../styles");
// decorate
const decorate_1 = require("./decorate");
exports.buttonClassName = styles_1.generateStaticClassName('Button');
exports.buttonLabelClassName = styles_1.generateStaticClassName('Button--label');
const Button = react_1.default.forwardRef(function Button(props, ref) {
    const { children, classes, color = 'default', variant = 'text', className, size = 'md', disabled, component: Component = 'button' } = props, rest = __rest(props, ["children", "classes", "color", "variant", "className", "size", "disabled", "component"]);
    return (react_1.default.createElement(Component, Object.assign({ type: "button" }, rest, { ref: ref, disabled: disabled, className: clsx_1.default(exports.buttonClassName, classes.root, classes[`size-${size}`], {
            [classes[`text-${color}`]]: variant === 'text',
            [classes[`contained-${color}`]]: variant === 'contained',
            [classes[`outlined-${color}`]]: variant === 'outlined',
            [classes.disabled]: disabled,
        }, className) }),
        react_1.default.createElement("span", { className: clsx_1.default(exports.buttonLabelClassName, classes.label) }, children)));
});
if (process.env.NODE_ENV !== 'production') {
    Button.displayName = 'Button';
}
const StyledButton = decorate_1.decorate(Button);
exports.Button = StyledButton;
